import { SITE_BRAND_NAME } from '@/constants/siteContact';

/** All supported inquiry channels — drives API validation and email subject lines. */
export const INQUIRY_TYPE_IDS = [
  'consultation',
  'contact',
  'feedback',
  'support',
  'partnership',
  'careers',
  'general',
] as const;

export type InquiryTypeId = (typeof INQUIRY_TYPE_IDS)[number];

export type InquiryTypeDefinition = {
  id: InquiryTypeId;
  /** i18n key under `inquiry.types.{id}` */
  labelKey: string;
  /** Subject prefix before dynamic suffix (name / company). */
  subjectPrefix: string;
};

export const INQUIRY_TYPES: readonly InquiryTypeDefinition[] = [
  { id: 'consultation', labelKey: 'consultation', subjectPrefix: 'Consultation request' },
  { id: 'contact', labelKey: 'contact', subjectPrefix: 'Contact inquiry' },
  { id: 'feedback', labelKey: 'feedback', subjectPrefix: 'Feedback' },
  { id: 'support', labelKey: 'support', subjectPrefix: 'Support request' },
  { id: 'partnership', labelKey: 'partnership', subjectPrefix: 'Partnership inquiry' },
  { id: 'careers', labelKey: 'careers', subjectPrefix: 'Careers inquiry' },
  { id: 'general', labelKey: 'general', subjectPrefix: 'General inquiry' },
] as const;

const TYPE_BY_ID = new Map(INQUIRY_TYPES.map((t) => [t.id, t]));

export function isInquiryTypeId(value: string): value is InquiryTypeId {
  return (INQUIRY_TYPE_IDS as readonly string[]).includes(value);
}

export function getInquiryType(id: InquiryTypeId): InquiryTypeDefinition {
  return TYPE_BY_ID.get(id)!;
}

export function buildInquirySubject(
  typeId: InquiryTypeId,
  name: string,
  company?: string
): string {
  const type = getInquiryType(typeId);
  const who = company?.trim() ? `${name.trim()} (${company.trim()})` : name.trim();
  return `[${SITE_BRAND_NAME}] ${type.subjectPrefix} — ${who}`;
}
